var map = {
	"./add.svg": 543,
	"./add_queue.svg": 544,
	"./album.svg": 545,
	"./blue_dot_icon.svg": 546,
	"./caret_down.svg": 547,
	"./caret_up.svg": 548,
	"./cart.svg": 549,
	"./collection.svg": 550,
	"./copy.svg": 551,
	"./delete.svg": 552,
	"./download.svg": 553,
	"./edit.svg": 554,
	"./favorite.svg": 555,
	"./info_panel.svg": 556,
	"./info_round.svg": 557,
	"./init_editor.svg": 558,
	"./instrument.svg": 559,
	"./menu.svg": 560,
	"./natural_language.svg": 561,
	"./open_editor.svg": 562,
	"./quick_filter.svg": 563,
	"./radio.svg": 564,
	"./save.svg": 565,
	"./search.svg": 566,
	"./share_add_person.svg": 567,
	"./share_copy_link.svg": 568,
	"./similar_tracks.svg": 569,
	"./sort.svg": 570,
	"./tag.svg": 571,
	"./text_search.svg": 572,
	"./track.svg": 573,
	"./upload.svg": 574,
	"./variation.svg": 575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 870;